var map = {
	"./brushed_metal.vs": 172,
	"./from_taiwan.vs": 174,
	"./simple_texture.vs": 176,
	"./wood.vs": 178
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 205;



//////////////////
// WEBPACK FOOTER
// ./src/shaders ^\.\/.*\.vs$
// module id = 205
// module chunks = 5